import { ChildrenProp } from '@/common/types_and_interfaces.ts'
import { cn } from '@/common/utilities.ts'
import CopyRight from '@/layouts/CopyRight.tsx'

export const AuthLayout = ({ children }: ChildrenProp) => {
  return (
    <>
      <div className="bg-muted-white flex flex-1 flex-col justify-center py-12 sm:px-6 lg:px-8">
        {children}
      </div>

      <div className="flex text-sm justify-center font-normal items-center gap-2 mb-2">
        <CopyRight />
      </div>
    </>
  )
}

type LayoutContentProps = { className?: string } & ChildrenProp
const LayoutContent = ({ children, className }: LayoutContentProps) => {
  return (
    <div className="mx-auto w-full max-w-[380px]">
      <main
        className={cn(
          'bg-white px-10 py-10 border border-gray-50 sm:rounded-lg sm:shadow-md',
          className
        )}
      >
        {children}
      </main>
    </div>
  )
}

AuthLayout.Content = LayoutContent
